/* =========================================================================
   aw-v2-atelier.js — la vidéo de la section atelier, partout où elle vit.

   POURQUOI CE FICHIER EXISTE. L'observateur qui lance la vidéo au défilement
   était écrit deux fois : dans aw-v2-home.js et dans aw-v2-product.js. Or
   layout/theme.liquid ne charge ces deux-là que sur `index` et `product`. La
   section `aw-v2-atelier` pouvant être posée sur N'IMPORTE QUEL gabarit, elle
   s'est retrouvée sur /pages/l-atelier avec sa vidéo et personne pour la
   lancer — troisième occurrence de la même cause en trois chantiers.

   La correction est structurelle : le comportement suit désormais la SECTION,
   qui charge ce fichier elle-même. Aucun gabarit futur ne pourra plus l'oublier.

   La section ne le charge PAS sur `index` ni `product`, où les bundles de page
   portent déjà le même observateur : deux observateurs sur la même vidéo se
   marcheraient sur les pieds à chaque entrée d'écran.

   Mêmes règles qu'ailleurs : son coupé AVANT play(), pause hors écran, seuil
   de 50 %, et `prefers-reduced-motion` annule la lecture automatique sans
   retirer le bouton de son — c'est alors le seul moyen de lancer.
   ========================================================================= */
(function () {
  'use strict';

  var MOINS_DE_MOUVEMENT = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function atelier(racine) {
    /* Garde-fou : si un bundle de page a deja pris la main sur cette section,
       on ne repose pas un second observateur. */
    if (racine.dataset.awv2AtelierPret === '1') return;
    racine.dataset.awv2AtelierPret = '1';

    var video = racine.querySelector('video');
    if (!video) return;

    video.setAttribute('playsinline', '');
    var sonVoulu = false;

    function lire() {
      if (!sonVoulu) video.muted = true;          // toujours AVANT play()
      var p = video.play();
      if (p && p.catch) p.catch(function () { /* lecture refusee : sans consequence */ });
    }

    if (!MOINS_DE_MOUVEMENT && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (entrees) {
        entrees.forEach(function (e) {
          if (e.isIntersecting) { lire(); } else { video.pause(); }
        });
      }, { threshold: 0.5 }).observe(video);
    }

    var bouton = racine.querySelector('[data-awv2-son]');
    if (!bouton) return;

    function refleter() {
      var coupe = video.muted;
      bouton.setAttribute('aria-pressed', coupe ? 'false' : 'true');
      bouton.setAttribute('aria-label', coupe ? 'Activer le son' : 'Couper le son');
      bouton.classList.toggle('is-actif', !coupe);
    }

    bouton.addEventListener('click', function () {
      video.muted = !video.muted;
      sonVoulu = !video.muted;
      if (sonVoulu) {
        var p = video.play();
        if (p && p.catch) p.catch(function () {});
      }
      refleter();
    });

    refleter();
  }

  function demarrer() {
    document.querySelectorAll('[data-awv2="atelier"]').forEach(atelier);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', demarrer);
  } else {
    demarrer();
  }
})();
